// Feather font icon - For form-wizard
require('@core/assets/fonts/feather/iconfont.css') // For form-wizard

// Fontawesome font icon - For form-wizard
import '../@core/assets/fonts/fontawesome/css/all.css' // For form-wizard
// require('@core/assets/fonts/fontawesome/css/brands.css') // For form-wizard
// require('@core/assets/fonts/fontawesome/css/solid.css') // For form-wizard
// require('@core/assets/fonts/fontawesome/css/regular.css') // For form-wizard
